import React, { useEffect } from "react";
import Sheet from "./Sheet";
import useMediaQuery from "./useMediaQuery";

// A bottom sheet on phones, a centred dialog on wide screens. Same content either way.
export default function SheetOrDialog({ open, onClose, label, children }) {
  const wide = useMediaQuery("(min-width: 768px)");

  useEffect(() => {
    if (!open || !wide) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, wide, onClose]);

  if (wide) {
    if (!open) return null;
    return (
      <div className="rg-dialog-backdrop" onClick={onClose}>
        <div className="rg-dialog" role="dialog" aria-modal="true" aria-label={label} onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      </div>
    );
  }

  return (
    <Sheet open={open} onClose={onClose} label={label}>
      {children}
    </Sheet>
  );
}
